var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box, theme, ThemeProvider, CloseOutlinedIcon, } from '@kareo/design-system';
import ImgTerminal from 'shared-assets/assets/img/terminal-new.svg';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import { IconButton } from '@material-ui/core';
import styled from 'styled-components';
var PLG_SCREEN_SHOW_KEY = 'plg-screen-close';
var WEB_PAGE_URL = '/v2/#/payments-onboarding';
var CloseAdButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 4px;\n  right: 4px;\n"], ["\n  position: absolute;\n  top: 4px;\n  right: 4px;\n"])));
var PlgScreenAdView = function () {
    var _a = React.useState(false), closePlgScreenPanel = _a[0], setClosePlgScreenPanel = _a[1];
    var handleAdClick = function () {
        sessionStorage.setItem('tebraPaymentsTopOfFunnel', 'Collect Payment Screen');
        window.location.href = WEB_PAGE_URL;
    };
    var handleAdClose = function () {
        setClosePlgScreenPanel(true);
        localStorage.setItem(PLG_SCREEN_SHOW_KEY, JSON.stringify({ plgScreenPanel: true }));
    };
    var dsTheme = getDesignSystemTheme();
    var getIsAdVisible = React.useMemo(function () {
        if (closePlgScreenPanel) {
            return false;
        }
        var adsStorage = localStorage.getItem(PLG_SCREEN_SHOW_KEY);
        if (!!adsStorage) {
            var adsStorageParsed = JSON.parse(adsStorage);
            if (adsStorageParsed.plgScreenPanel) {
                return false;
            }
        }
        return true;
    }, [closePlgScreenPanel]);
    return (React.createElement(React.Fragment, null, getIsAdVisible && (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(Card, null,
            React.createElement(CardMedia, { component: "img", image: ImgTerminal }),
            React.createElement(CloseAdButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleAdClose },
                React.createElement(CloseOutlinedIcon, { fontSize: "inherit" })),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h4", align: "center", style: {
                        lineHeight: '20px',
                        margin: '0 0 13px 0',
                        color: theme.palette.primary.main,
                    } },
                    "Automate your patient billing with ",
                    React.createElement("br", null),
                    " Tebra Payments."),
                React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", alignItems: "center" },
                    React.createElement(Button, { color: "vitality", onClick: handleAdClick }, "Discover Tebra Payments!"))))))));
};
export default PlgScreenAdView;
var templateObject_1;
